module.exports = __webpack_public_path__ + "img/img_03.9fe87c09.png";